import { Placeholder } from "../../../../../../../components/Placeholder/Placeholder"

export const LoaderFormCalendar = () => {
    return (
        <div className="px-4 py-3">

            <div className='row'>
                <div className="mb-3 col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-xxl-3">
                    <Placeholder className='py-2' height='2rem' />
                </div>

                <div className="col-12"></div>

                <div className="mb-3 col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-xxl-3">
                    <Placeholder className='py-2 delay-1' height='5rem' />
                </div>

                <div className="mb-3 col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-xxl-3">
                    <Placeholder className='py-2 delay-2' height='5rem' />
                </div>

                <div className="mb-3 col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-xxl-3">
                    <Placeholder className='py-2 delay-3' height='5rem' />
                </div>

                <div className="mb-3 col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-xxl-3">
                    <Placeholder className='py-2 delay-4' height='5rem' />
                </div>

                <div className="mb-3 col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-xxl-3">
                    <Placeholder className='py-2 delay-5' height='5rem' />
                </div>
            </div>
        </div>
    )
}
